import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Support from "../../store/SupportTab";
import { ApplicationState } from "../../store";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds } from "../../config/UserServicesList";
import SupportNew from "./Support";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useTranslation } from "react-i18next";

const IncidentResponseSupportTab = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const dispatch = useDispatch();

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const IncidenceActiveServices = useAreServicesActive([ezsServiceIds.businessIncidentResponseForensics]);

    let ClaimFriendlyName;
    let ClaimFriendlyPhoneNumber;
    const PartnerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const PartnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const RetailerName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerName
            ? state.configurationState.configuration.partnerConfig.retailerName
            : ""
    );
    const RetailerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );

    if (RetailerName && RetailerPhoneNumber) {
        ClaimFriendlyName = RetailerName;
        ClaimFriendlyPhoneNumber = RetailerPhoneNumber;
    } else {
        ClaimFriendlyName = PartnerName;
        ClaimFriendlyPhoneNumber = PartnerPhoneNumber;
    }

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1>{tLang("supportSection.supportTitleText")}</h1>
                </div>
            </div>

            <Support selectedTab={IncidenceActiveServices ? "3" : "1"} />
            {IncidenceActiveServices ? (
                <div className="support-container row">
                    <div className="col-xs-12 row">
                        <div className="box no-padding">
                            <div className="contentBox">
                                <h2>{tLang("supportSection.incidentResponsetForensicsWidget.title")}</h2>
                                <p className="para">{tLang("supportSection.incidentResponsetForensicsWidget.message")}</p>
                                <p><u>{tLang("supportSection.incidentResponsetForensicsWidget.ExclusionsMessage")}</u></p>
                                <h3>{tLang("supportSection.incidentResponsetForensicsWidget.suspectDataTitle")}</h3>
                                <p className="sectionPara">
                                    {tLang("supportSection.incidentResponsetForensicsWidget.suspectCallRetailerPartnerName", {
                                        ClaimFriendlyName: ClaimFriendlyName,
                                    })}
                                </p>
                            </div>
                            <div className="contentBox">
                                <h3>{tLang("supportSection.incidentResponsetForensicsWidget.systemCompromiseTitle")}</h3>
                                <p className="sectionPara">{tLang("supportSection.incidentResponsetForensicsWidget.systemGainElevetedMessage")}</p>
                                <ul className="listStyleType">
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.systemBackgroundDetailsMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.systemExecutiveSummaryMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.systemDataExfiltrationMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.systemActionsTakenMessage")}</li>
                                </ul>
                            </div>
                            <div className="contentBox">
                                <h3>{tLang("supportSection.incidentResponsetForensicsWidget.ransomwareTitle")}</h3>

                                <p className="sectionPara">{tLang("supportSection.incidentResponsetForensicsWidget.ransomwareOperationsMessage")}</p>

                                <ul className="listStyleType">
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareCommunicateMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareObtainProofMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareLaunderingCheckMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareBitcoinWalletMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareDecryptionKeyMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.ransomwareSupportClientMessage")}</li>
                                </ul>
                            </div>
                            <div className="contentBox">
                                <h3>{tLang("supportSection.incidentResponsetForensicsWidget.businessEmailTitle")}</h3>
                                <p className="sectionPara">{tLang("supportSection.incidentResponsetForensicsWidget.businessOurBusinessMessage")}</p>

                                <ul className="listStyleType">
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.businessDetailsOfEventMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.businessFindingsMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.businessDataExfiltrationMessage")}</li>
                                    <li> {tLang("supportSection.incidentResponsetForensicsWidget.businessEvidenceShowingMessage")}</li>
                                </ul>
                            </div>
                            <div className="contentBox">
                                <h3>{tLang("supportSection.incidentResponsetForensicsWidget.dataMiningTitle")}</h3>
                                <p className="sectionPara">{tLang("supportSection.incidentResponsetForensicsWidget.dataBusinessOwnerMessage")}</p>

                                <ul className="listNewStyleType">
                                    <li>
                                        <p> {tLang("supportSection.incidentResponsetForensicsWidget.dataBackgroundSummaryMessage")}</p>
                                    </li>
                                    <li>
                                        <p> {tLang("supportSection.incidentResponsetForensicsWidget.dataRawResultsMessage")}</p>
                                    </li>
                                    <li>
                                        <p> {tLang("supportSection.incidentResponsetForensicsWidget.dataOptionForMessage")}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="support-container row">
                    <div className="col-xs-12 row">
                        <div className="contentBox">
                            <SupportNew setForm="" setSupportIdentityThreatState="" supportIdentityThreatState="" onClose="" />
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default IncidentResponseSupportTab;
